const SAFE_PROTOCOLS = new Set(["http:", "https:"]);

/**
 * Ссылка из данных обращения (вложение, платёж) только со схемой http(s)
 * или относительным путём; javascript:, data: и прочее дают null, и
 * вызывающий показывает обычный текст вместо ссылки.
 */
export function safeHref(url: string | null | undefined): string | null {
  const value = url?.trim();
  if (!value) return null;
  try {
    // База нужна только относительным путям: их схема станет https.
    const parsed = new URL(value, "https://relative.invalid");
    return SAFE_PROTOCOLS.has(parsed.protocol) ? value : null;
  } catch {
    return null;
  }
}
